import { render } from "./TotalRevenueChart.vue?vue&type=template&id=e8192b24&ts=true"
import script from "./TotalRevenueChart.vue?vue&type=script&lang=ts"
export * from "./TotalRevenueChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__